module.exports = __webpack_public_path__ + "img/zss_lct.7d5a5697.png";